import { useEffect } from 'react';

interface UseDismissibleOverlayOptions {
  isOpen: boolean;
  onClose: () => void;
  disablePullToRefresh?: boolean;
}

const setPullToRefreshDisabled = (disabled: boolean) => {
  document.body.classList.toggle('no-pull-to-refresh', disabled);
};

const isDismissKey = (event: KeyboardEvent) => event.key === 'Escape';

const useDismissibleOverlay = ({
  isOpen,
  onClose,
  disablePullToRefresh = false,
}: UseDismissibleOverlayOptions): void => {
  useEffect(() => {
    if (!isOpen) {
      if (disablePullToRefresh) {
        setPullToRefreshDisabled(false);
      }
      return;
    }

    if (disablePullToRefresh) {
      setPullToRefreshDisabled(true);
    }

    const handleKeyDown = (event: KeyboardEvent) => {
      if (isDismissKey(event)) {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      if (disablePullToRefresh) {
        setPullToRefreshDisabled(false);
      }
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [disablePullToRefresh, isOpen, onClose]);
};

export default useDismissibleOverlay;
